const HTMLUtil = require('utilities/html');
const _ = require('underscore');
const optimizedResize = require('utilities/optimizedResize');

const triggerParentMarginDownCycle = el => {
	const parent = el.parentElement;

	if (!parent.marginDownParent) {
		// when any one element changes its top value we want the parent to look at all
		// the elements. The top values might also be changed in a loop, so we're using
		// throttle to cap how much this gets called. Using debounce causes the annotations
		// to jerk around as the position is briefly wrong. Throttle works better since it calls
		// both at the beginning and the end of its timeout (the end call is only made if
		// another call came in during the wait)

		parent.marginDownParent = _.throttle(function () {
			parent.querySelectorAll('.margin-to-el').forEach(child => {
				child.style.position = 'static';
				child.marginDown();
			});
		}, 30);

		optimizedResize.add(parent.marginDownParent);
	}

	parent.marginDownParent();
};

function marginDown() {
	const top = Math.round(Number(this.dataset.top));
	const currentMargin = Number(this.style.marginTop.replace('px', ''));
	const normalTop = this.offsetTop - currentMargin;

	const diff = Math.round(top - normalTop);

	this.style.visibility = 'visible';

	if (diff > 0) {
		this.style.marginTop = `${diff}px`;
	} else {
		this.style.marginTop = '';
	}
}

module.exports = {
	bind(el, binding) {
		el.classList.add('margin-to-el');
		el.dataset.top = binding.value || 0;

		el.style.visibility = 'hidden';
		el.style.position = 'absolute';
		el.marginDown = marginDown;
	},
	inserted(el) {
		HTMLUtil.whenInDOM(el, () => {
			triggerParentMarginDownCycle(el);
		});
	},
	update(el, { value, oldValue }) {
		if (value !== oldValue) {
			el.dataset.top = value || 0;

			HTMLUtil.whenInDOM(el, () => {
				triggerParentMarginDownCycle(el);
			});
		}
	},
	unbind(el) {
		const parent = el.parentElement;
		if (parent) {
			if (parent.querySelectorAll('.margin-to-el').length === 1) {
				optimizedResize.remove(parent.marginDownParent);
				parent.marginDownParent = undefined;
			} else if (parent.marginDownParent) {
				parent.marginDownParent();
			}
		}
		el.classList.remove('margin-to-el');
		el.marginDown = undefined;
	}
};
